import React from 'react';
import {
  Card, CardBody, CardTitle, Link, Typography
} from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { Edit, Info } from '@one-thd/sui-icons';
import { ADDRESS_PATH, PRIVACY_PATH, SECURITY_PATH } from '../constants';
import { isB2CUser } from '../../utils/general';
import { handlePhoneFormat } from './common/helper';

const InfoBox = ({ email, phoneNumber, tabValue }) => {

  const isProXtraEnabled = useConfigService('proxtra_component_enabled');

  function determineTypography(val) {

    if (val === 'Personalization Tab') {
      return (
        <Typography variant="body-base">
          {`You can view and manage your communication preferences to receive savings
          and project ideas, help us improve our services and products, or to opt out of
          these communications. Use this page to tell us how you’d like to receive these
          communications. These preferences will not affect communications such as: account
          statements, online order details, customer service inquires, etc. The preferences
          that you have entered will be honored in accordance with our `}
          <Link underline="always" href={PRIVACY_PATH}>
            Privacy and Security Statement
          </Link>.
        </Typography>
      );
    }

    return (
      <Typography variant="body-base">
        <>
          <Typography variant="body-base">
            {'Manage how you receive communications from us at '}
            <Typography component="b" weight="bold">
              {email},&nbsp;
            </Typography>
            <Typography component="b" weight="bold">
              {handlePhoneFormat(phoneNumber)}
            </Typography>
            {handlePhoneFormat(phoneNumber) === '' ? '' : ', '}
            {'and your mailing address. '}
            {'For details on how we handle your personal information, see our  '}
            <Link underline="always" href={PRIVACY_PATH}>
              Privacy & Security Statement
            </Link>.
          </Typography>
          &nbsp;
          <Card>
            <div className="sui-flex sui-items-center sui-gap-2 sui-mb-2">
              <Edit />
              <Typography variant="h4" weight="bold">
                Need to change your contact information?
              </Typography>
            </div>

            <Typography variant="body-lg">
              {'To update your '}
              <Typography component="b" weight="bold">
                email
              </Typography>
              {' or '}
              <Typography component="b" weight="bold">
                phone number
              </Typography>
              {', go to your '}
              <Link underline="always" href={SECURITY_PATH}>
                Security & Password
              </Link>
              {' page.'}
            </Typography>
            <Typography variant="body-lg">
              {'Update your '}
              <Typography component="b" weight="bold">
                mailing address
              </Typography>
              {' on the '}
              <Link underline="always" href={ADDRESS_PATH}>
                Addresses
              </Link>
              {' page.'}
            </Typography>
            <Typography color="subtle">
              <div className="sui-flex sui-items-center sui-gap-2">
                <Info color="info" />
                <Typography color="subtle">
                  {' You can find both of these pages under '}
                  <Typography component="b" weight="bold" color="subtle">
                    Account Settings
                  </Typography>
                  {' in the left hand menu.'}
                </Typography>
              </div>
            </Typography>
          </Card>
        </>
      </Typography>

    );
  }

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">
        MANAGE YOUR PREFERENCES
      </Typography>
      {(!isB2CUser() && isProXtraEnabled)
        ? (
          <Typography variant="body-base">
            <>
              <Typography variant="body-base">
                {'Manage your Pro Xtra marketing and survey preferences sent to '}
                <Typography component="b" weight="bold">
                  {email},&nbsp;
                </Typography>
                <Typography component="b" weight="bold">
                  {handlePhoneFormat(phoneNumber)}
                </Typography>
                {' and by postal mail. You can update your email and phone number at '}
                <Link underline="always" href={SECURITY_PATH}>
                  Security & Password
                </Link>
                {' and your mailing address at '}
                <Link underline="always" href={ADDRESS_PATH}>
                  Addresses
                </Link>.
                {' Your personal information is protected by our '}
                <Link underline="always" href={PRIVACY_PATH}>
                  Privacy and Security Statement
                </Link>.
              </Typography>
              <br />
              <Typography variant="body-base">
                Note that your changes won’t affect communications such as:
              </Typography>
              <br />
              <ul className="sui-list-disc sui-ml-5">
                <li>Account statements</li>
                <li>Online order details</li>
                <li>Customer service inquires</li>
              </ul>
            </>
          </Typography>
        )
        : (
          determineTypography(tabValue)
        )}
    </div>
  );
};

const proptypes = {
  email: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  tabValue: PropTypes.string.isRequired
};

InfoBox.propTypes = proptypes;

export default InfoBox;
